import rxc1 from "assets/recentTicket.svg";
import rx2 from "assets/rxc1.svg";
import inventry1 from 'assets/inventry.svg'
import inventry from "assets/serviceChannel.svg";
import health from "assets/workbrain.svg";
import reports from "assets/myCustomer.svg";
import EpicIcon from "assets/thinkLp.svg";
import EpicIcon1 from "assets/epic.svg";
import PicPack from "assets/health.svg";
import epic from 'assets/epic.svg'
import myWork from 'assets/myWork.svg'
import myDoc from 'assets/myDoc.svg'
import reportsMain from "assets/reports.svg";
import MyWorkIcon from "assets/myColleagues.svg";
import MyDocIcon from "assets/namebadge.svg";
import Createticket from "assets/createTicket.svg";
import cord from "assets/cord.svg";
import ironman from "assets/ironman.svg";
import ironmanBattery from "assets/ironmanBattery.svg";
import ironmancase from "assets/ironmancase.svg"
import trigger from "assets/trigger.svg"
import sharp from "assets/sharp.svg"
import keyboard from "assets/keyboard.svg"
import mouse from "assets/mouse.svg"
import registerCenter from "assets/registerCenter.svg"
import registerPrinterBlack from "assets/registerPrinterBlack.svg"
import registerScanner from "assets/registerScanner.svg"
import learningHub from "assets/learningHub.svg"
import cz from "assets/cz.svg"
import time from "assets/time.svg"
import reduser from "assets/reduser.svg"
import heartWork from "assets/heartWork.svg"
import mySuccess from "assets/mySuccess.svg"
import myPassword from "assets/myPassword.svg"
import myInsight from "assets/myInsight.svg"
import CSVAppIcon from "assets/cvsApp.svg";

export const States = [
  { label: "Alabama", abbreviation: "AL" },
  { label: "Alaska", abbreviation: "AK" },
  { label: "Arizona", abbreviation: "AZ" },
  { label: "Arkansas", abbreviation: "AR" },
  { label: "California", abbreviation: "CA" },
  { label: "Colorado", abbreviation: "CO" },
  { label: "Connecticut", abbreviation: "CT" },
  { label: "Delaware", abbreviation: "DE" },
  { label: "Florida", abbreviation: "FL" },
  { label: "Georgia", abbreviation: "GA" },
  { label: "Hawaii", abbreviation: "HI" },
  { label: "Idaho", abbreviation: "ID" },
  { label: "Illinois", abbreviation: "IL" },
  { label: "Indiana", abbreviation: "IN" },
  { label: "Iowa", abbreviation: "IA" },
  { label: "Kansas", abbreviation: "KS" },
  { label: "Kentucky", abbreviation: "KY" },
  { label: "Louisiana", abbreviation: "LA" },
  { label: "Maine", abbreviation: "ME" },
  { label: "Maryland", abbreviation: "MD" },
  { label: "Massachusetts", abbreviation: "MA" },
  { label: "Michigan", abbreviation: "MI" },
  { label: "Minnesota", abbreviation: "MN" },
  { label: "Mississippi", abbreviation: "MS" },
  { label: "Missouri", abbreviation: "MO" },
  { label: "Montana", abbreviation: "MT" },
  { label: "Nebraska", abbreviation: "NE" },
  { label: "Nevada", abbreviation: "NV" },
  { label: "New Hampshire", abbreviation: "NH" },
  { label: "New Jersey", abbreviation: "NJ" },
  { label: "New Mexico", abbreviation: "NM" },
  { label: "New York", abbreviation: "NY" },
  { label: "North Carolina", abbreviation: "NC" },
  { label: "North Dakota", abbreviation: "ND" },
  { label: "Ohio", abbreviation: "OH" },
  { label: "Oklahoma", abbreviation: "OK" },
  { label: "Oregon", abbreviation: "OR" },
  { label: "Pennsylvania", abbreviation: "PA" },
  { label: "Rhode Island", abbreviation: "RI" },
  { label: "South Carolina", abbreviation: "SC" },
  { label: "South Dakota", abbreviation: "SD" },
  { label: "Tennessee", abbreviation: "TN" },
  { label: "Texas", abbreviation: "TX" },
  { label: "Utah", abbreviation: "UT" },
  { label: "Vermont", abbreviation: "VT" },
  { label: "Virginia", abbreviation: "VA" },
  { label: "Washington", abbreviation: "WA" },
  { label: "West Virginia", abbreviation: "WV" },
  { label: "Wisconsin", abbreviation: "WI" },
  { label: "Wyoming", abbreviation: "WY" },
];

export const CameraConfig = {
  elementId: "userVideo",
  mode: "front",
  requireHD: false,
};

export const AUTH = "AUTH";
export const ELEMENT_ID = "userVideo";
export const FLOW = {
  CREATE_USER: 1,
  UPLOAD_SELFIE: 2,
  UPLOAD_DOC_FRONT: 3,
  UPLOAD_DOC_BACK: 4,
};
export const THRESHOLD = 21;
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const REQUIRES_INPUT = "REQUIRES_INPUT";
export const REMOVE_GLASSES = "Remove glasses";
export const ERROR = "error";
export const PASSKEY_BASE_URL = "https://simplewebauthn.privateid.com";
export const ECHO = "echo";
export const TELE = "tele";
export const AUTHENTICATION_FAILED = "Authentication failed!";
export const ACCOUNT_CREATION_FAILED = "Account Creation Failed";
export const ACCOUNT_NOT_APPROVED = "Your account is not approved.";
export const UNABLE_TO_VERIFY = "Unable to Verify Credentials.";

export const ENROLL_CANVAS_RESOLUTION = { width: 800, height: 600 };
export const IPAPI_API = "https://ipapi.co/json/";
export const PIN = "9999";
export const SWITCH_DEVICE = "Switch Device";
export const SECURITY_CHALLENGE = "security-challenge";

export const languageCodes = {
  English: "en",
  "English (British)": "en-GB",
  български: "bg",
  hrvatski: "hr",
  čeština: "cs",
  dansk: "da",
  Nederlands: "nl",
  "eesti keel": "et",
  suomi: "fi",
  français: "fr",
  Deutsch: "de",
  ελληνικά: "el",
  magyar: "hu",
  Gaeilge: "ga",
  italiano: "it",
  "latviešu valoda": "lv",
  "lietuvių kalba": "lt",
  Malti: "mt",
  polski: "pl",
  português: "pt",
  română: "ro",
  slovenčina: "sk",
  slovenščina: "sl",
  español: "es",
  svenska: "sv",
  العربية: "ar",
  català: "ca",
  "español (Latinoamérica)": "es-419",
  فارسی: "fa",
  Filipino: "fil",
  हिन्दी: "hi",
  "Bahasa Indonesia": "id",
  עברית: "iw",
  日本語: "ja",
  한국어: "ko",
  norsk: "no",
  русский: "ru",
  српски: "sr",
  ไทย: "th",
  Türkçe: "tr",
  українська: "uk",
  "Tiếng Việt": "vi",
  中文: "zh",
  "中文（台灣）": "zh-TW",
};

export const pagesRoute = {
  home: "/",
  userConsent: "/user-consent",
  userInfo: "/user-info",
  switchDevice: "/switch-device",
  redirectedMobile: "/redirected-mobile",
  faceScanIntro: "/face-scan-intro",
  faceScan: "/face-scan",
  docSelection: "/doc-selection",
};

export const loginOptions = [
  "passkey",
  "loginPin",
  "loginDl",
  "loginVc",
  "checkoutVc",
  "faceLogin",
];

export const FooterItems = [
  {
    id: 3,
    label: " Privacy",
    link: "https://github.com/openinfer/PrivateIdentity/wiki/Privacy-Policy",
  },
  {
    id: 2,
    label: "Terms",
    link: "https://github.com/openinfer/PrivateIdentity/wiki/Terms-of-Use",
  },
  {
    id: 1,
    label: "Feedback",
    link: null,
  },
];

export const EQUIFAX_FLOWS = ["Workforce", "Consumer"];

export const Workforce = [
  {
    title: "Register",
    value: "register",
    enable: true,
    type: EQUIFAX_FLOWS[0],
  },
  {
    title: "Login with face scan",
    value: "faceLogin",
    enable: true,
    type: EQUIFAX_FLOWS[0],
  },
  {
    title: "Login with pin",
    value: "loginPin",
    enable: true,
    type: EQUIFAX_FLOWS[0],
  },
  {
    title: "Login with driver's license",
    value: "loginDl",
    enable: true,
    type: EQUIFAX_FLOWS[0],
  },
  {
    title: "Check out with verifiable credentials",
    value: "checkoutVc",
    enable: true,
    type: EQUIFAX_FLOWS[0],
  },
];

export const Consumer = [
  {
    title: "Register",
    value: "register",
    enable: true,
    type: EQUIFAX_FLOWS[1],
  },
  {
    title: "Click to pay with face",
    value: "faceLogin",
    enable: true,
    type: EQUIFAX_FLOWS[1],
  },
  {
    title: "Click to pay with pin",
    value: "loginPin",
    enable: true,
    type: EQUIFAX_FLOWS[1],
  },
  {
    title: "Click to pay with driver's license",
    value: "loginDl",
    enable: true,
    type: EQUIFAX_FLOWS[1],
  },
  {
    title: "Click to pay with verifiable credentials",
    value: "checkoutVc",
    enable: true,
    type: EQUIFAX_FLOWS[1],
  },
];

export const ALL_FLOWS = [...Workforce, ...Consumer];
export const DEVEL_ORCHESTRATION =
  "https://api.orchestration.devel.privateid.com";

export enum VerificationSessionType {
  AGE = "AGE",
  IDENTITY = "IDENTITY",
  AUTH = "AUTH",
}

export const RESOLUTIONS = [
  {
    label: "1920 * 1080",
    value: { width: 1920, height: 1080 },
  },
  {
    label: "1280 * 720",
    value: { width: 1280, height: 720 },
  },
  {
    label: "800 * 600",
    value: { width: 800, height: 600 },
  },
  {
    label: "640 * 480",
    value: { width: 640, height: 480 },
  },
];

export const embeddings =
  "[0.04206985607743263,-0.05116783827543259,-0.04002778232097626,0.07223024219274521,0.04652908816933632,-0.02654893696308136,0.0404941588640213,-0.06745322048664093,0.06275619566440582,0.03354455158114433,0.04594433680176735,-0.00024526019115000963,-0.0029720475431531668,0.0027592412661761045,-0.06071123108267784,0.010937553830444813,-0.023827241733670235,-0.1067422479391098,0.006274257320910692,-0.018895257264375687,0.02301810123026371,-0.011892145499587059,0.05186224728822708,0.06591596454381943,-0.034368038177490234,-0.06792464107275009,0.02635795623064041,-0.03953946754336357,0.008251491002738476,0.038952313363552094,0.04774882271885872,0.09358448535203934,-0.010309109464287758,-0.00940544530749321,0.00752975232899189,-0.03398546576499939,0.025146400555968285,-0.07537658512592316,-0.0357326902449131,-0.08996058255434036,-0.06128351017832756,-0.005270096939057112,0.028850164264440536,-0.013233221136033535,0.06541654467582703,-0.07817817479372025,0.0024568841326981783,-0.06610787659883499,0.032815828919410706,-0.0005818783538416028,-0.014055831357836723,0.021190760657191277,-0.05460558459162712,-0.11918975412845612,-0.06607285887002945,-0.0068100192584097385,0.06591074168682098,0.04716828465461731,-0.0009464535396546125,0.016760775819420815,0.019195863977074623,-0.03856665641069412,0.007717990782111883,0.008285578340291977,-0.02580900304019451,0.02315543033182621,0.01600472815334797,0.032641004770994186,-0.025631627067923546,0.00023088493617251515,0.02657550573348999,-0.03009660355746746,-0.03916769474744797,0.03745453432202339,0.032607290893793106,0.03468566760420799,-0.013572141528129578,-0.028462396934628487,-0.03869690001010895,0.05367562547326088,0.0028871987015008926,-0.0062295133247971535,0.002872530836611986,0.03547447919845581,0.012188521213829517,-0.04141324386000633,-0.016906118020415306,-0.1293308585882187,0.11221279948949814,0.002880316460505128,-0.030874714255332947,0.042474109679460526,-0.005619230214506388,0.021824274212121964,0.020196419209241867,0.026394110172986984,-0.04435214400291443,0.015958959236741066,0.032551370561122894,0.04432445019483566,-0.018534697592258453,-0.011663072742521763,0.036814332008361816,-0.000585975416470319,-0.03704832121729851,0.030703118070960045,-0.03600084036588669,0.030598999932408333,-0.05757999047636986,-0.006322402972728014,-0.014553298242390156,-0.027763405814766884,-0.01383416261523962,0.038210321217775345,0.00007741194713162258,0.05818998068571091,-0.048384327441453934,-0.08766444027423859,0.014575020410120487,-0.09286563843488693,-0.0179462730884552,-0.015365749597549438,0.041947223246097565,0.051616404205560684,-0.08165592700242996,0.09814091771841049,0.051831137388944626,-0.03213215991854668,0.03939535468816757,-0.11601604521274567,-0.02932676672935486,-0.033771812915802,-0.024616746231913567,0.020587876439094543,0.03576730936765671,-0.020364051684737206,-0.07710085064172745,0.020722543820738792,-0.03547346591949463,0.028619782999157906,0.07154519855976105,0.06081414967775345,-0.02931133657693863,-0.060548074543476105,-0.07951725274324417,0.05908093973994255,0.015868788585066795,-0.0032649633940309286,-0.031670164316892624,0.05094711855053902,-0.07288526743650436,0.031021077185869217,0.0004380379104986787,0.010053391568362713,-0.01231445837765932,0.04238612949848175,0.1092216894030571,0.02245989814400673,0.03900987282395363,-0.02299269288778305,0.03019394911825657,-0.024341119453310966,-0.0031996441539376974,0.02104761451482773,-0.08254806697368622,-0.03009907342493534,0.04472979158163071,0.04599076509475708,0.05181611329317093,0.014624983072280884,-0.007194229401648045,-0.01534995250403881,-0.01592586375772953,0.025783704593777657,-0.04016198217868805,-0.0007175478967837989,-0.06411787122488022,-0.021618260070681572,0.025296242907643318,0.053462591022253036,-0.04931126534938812,0.0038807985838502645,-0.03427983075380325,-0.05538078024983406,0.13739457726478577,0.0010632436024025083,-0.07369944453239441,0.09036083519458771,0.01858583092689514,-0.01263362355530262,-0.029581289738416672,-0.0331658236682415,-0.039310257881879807,0.08085310459136963,0.046023208647966385,0.013429393991827965,0.004740396048873663,-0.009645059704780579,0.04913442209362984,0.027094071730971336,0.014420432969927788,0.033893898129463196,-0.028448021039366722,-0.012583799660205841,-0.046643223613500595,0.05192380025982857,-0.10282952338457108,0.06577928364276886,0.024046948179602623,-0.07596181333065033,0.020200403407216072,-0.005995197221636772,0.01822025701403618,-0.01221819780766964,0.0028118868358433247,0.005562653299421072,0.03547434136271477,-0.032107748091220856,-0.07731716334819794,-0.009830295108258724,0.009061220102012157,0.019520804286003113,-0.004005235154181719,-0.06788516789674759,0.0906582623720169,0.01924634911119938,0.04351692274212837,0.011989516206085682,-0.02729560248553753,0.05626201257109642,-0.06549650430679321,0.015542787499725819,0.06541644036769867,0.016166402027010918,-0.06173695623874664,0.015027022920548916,-0.0342567004263401,0.0009158344473689795,-0.009371497668325901,0.02292473614215851,0.020269546657800674,-0.0574793815612793,0.04680663347244263,0.01137635949999094,-0.012172026559710503,0.008417678996920586,0.010444248095154762,0.027959583327174187,-0.005898702889680862,0.02224843017756939,-0.0173642598092556,0.09485577046871185,0.008424543775618076,-0.05012977868318558,0.05252920836210251,-0.02718152478337288,0.011711373925209045,-0.05927367880940437,0.01084069348871708,-0.009702764451503754,-0.026977794244885445,-0.08997746556997299,0.047252342104911804,0.004286591894924641,0.02532045915722847,0.020222987979650497,0.08673392236232758,-0.0374053493142128,-0.029429281130433083,-0.02764245681464672,-0.00838590320199728,-0.10972427576780319,-0.03250948339700699,-0.11105666309595108,0.02365569770336151,-0.007136178202927113,-0.004705766215920448,0.02042365074157715,0.025406477972865105,-0.10539808124303818,0.027691543102264404,-0.04516635462641716,0.0528467558324337,0.0331680104136467,-0.003893709508702159,0.004818642046302557,0.06156902015209198,0.06749813258647919,-0.009663624688982964,-0.05245816335082054,0.028664585202932358,0.07317618280649185,-0.08197368681430817,-0.07813762128353119,-0.000241179543081671,-0.02858641743659973,0.058565009385347366,-0.056212738156318665,0.007747478783130646,0.04871947690844536,0.030076127499341965,-0.03405264392495155,-0.0413597971200943,0.05734109878540039,-0.007688459474593401,-0.025806788355112076,0.03331441059708595,-0.05714573338627815,0.02111862041056156,0.059381064027547836,-0.033468883484601974,0.03245116397738457,-0.04495243728160858,-0.02632911503314972,0.05854851379990578,-0.04172240570187569,-0.04455609247088432,0.020525315776467323,0.061241280287504196,0.016564248129725456,-0.023889826610684395,-0.05068739131093025,-0.039242614060640335,0.007234186865389347,-0.053363654762506485,0.033194031566381454,0.04844493046402931,-0.009169905446469784,-0.023911839351058006,-0.01085255853831768,-0.06993356347084045,0.003158947452902794,-0.00012031182995997369,-0.09026510268449783,-0.012733502313494682,-0.007205758709460497,-0.007843617349863052,-0.021819137036800385,-0.062362056225538254,-0.0160079225897789,-0.000035447548725642264,0.0424962043762207,-0.038822975009679794,0.08095505833625793,-0.0480949692428112,-0.025820337235927582,0.11450211703777313,0.019960442557930946,0.015594991855323315,-0.009930014610290527,-0.015614718198776245,-0.048266004770994186,-0.00682844640687108,0.06875962018966675,-0.02533848211169243,-0.002087813802063465,-0.028613440692424774,-0.01823904737830162,-0.038942523300647736,0.03963031619787216,-0.016324220225214958,-0.014276127330958843,0.008585321716964245,0.01955714449286461,-0.01139122899621725,-0.04563445597887039,-0.0013644269201904535,-0.005946992430835962,-0.011322131380438805,0.056114520877599716,-0.06659006327390671,-0.013141467235982418,-0.040652550756931305,-0.030465684831142426,0.006517330650240183,0.010795187205076218,0.04740327224135399,-0.00812552496790886,0.033359985798597336,0.04583531618118286,0.040516823530197144,0.05974412336945534,0.06931034475564957,-0.029837802052497864,0.0027412648778408766,0.0069510540924966335,0.09840954095125198,-0.010599308647215366,0.028245151042938232,0.03767939284443855,0.005917470436543226,0.02765967883169651,0.10253884643316269,-0.03857715055346489,-0.019108060747385025,-0.07516814768314362,0.053042616695165634,0.07349923253059387,0.01085276622325182,-0.10777556896209717,0.04521404951810837,-0.07536060363054276,-0.003924813121557236,-0.002757767913863063,0.03678841516375542,0.007424426265060902,-0.0019958638586103916,-0.029150409623980522,0.01648266240954399,0.007501349318772554,0.04009033367037773,-0.00882963091135025,-0.06130579859018326,0.012317093089222908,0.015803271904587746,-0.020650533959269524,-0.04179900512099266,0.05982634797692299,0.007506120018661022,-0.014498756267130375,0.0041856542229652405,-0.04618951678276062,0.05336226895451546,0.021188436076045036,-0.030903862789273262,-0.09556714445352554,-0.038210708647966385,0.02187691070139408,0.027042092755436897,0.0007289241766557097,0.013046192936599255,-0.0237086471170187,-0.05887685716152191,0.027565067633986473,-0.040916163474321365,0.027982434257864952,-0.01673210598528385,0.03733735904097557,-0.016213105991482735,-0.0988159030675888,-0.014607840217649937,-0.028308311477303505,-0.03962259739637375,-0.09278399497270584,0.03105407953262329,-0.07130340486764908,0.0030321606900542974,-0.006394765805453062,-0.037893638014793396,-0.06655319780111313,0.007662470452487469,-0.04521169885993004,-0.020776202902197838,0.020848672837018967,-0.0795426070690155,-0.03423076495528221,0.11332758516073227,0.07312449812889099,-0.06957265734672546,-0.057141292840242386,-0.013244213536381721,-0.010496450588107109,0.047675732523202896,-0.004406317602843046,0.04327823594212532,0.058907099068164825,-0.019735639914870262,-0.02150515653192997,0.0193255003541708,-0.029244640842080116,0.04269672557711601,0.0023200898431241512,-0.06349290162324905,-0.037557292729616165,-0.03118285723030567,0.03365642577409744,0.036178261041641235,-0.004575283732265234,0.03919423744082451,0.024122562259435654,0.030957836657762527,0.07272154092788696,0.042264606803655624,0.04579033702611923,-0.070506751537323,-0.02294071763753891,-0.012510467320680618,0.023923179134726524,-0.032138608396053314,-0.022549495100975037,0.017248637974262238,-0.05123947188258171,-0.023457210510969162,-0.014949632808566093,-0.04126293584704399,-0.06872386485338211,0.028079096227884293,-0.03716267645359039,-0.04659639298915863,-0.04868019372224808,-0.030237611383199692,0.030189357697963715,0.011247638612985611,0.02580900676548481,0.03781399503350258,0.03165247663855553,0.029726052656769753,0.06671734899282455,-0.03770432621240616,0.026218455284833908,-0.018126826733350754,0.04175872355699539]";


export const myShiftData = [
    {
      image: rx2,
      label: "RxConnect 1",
      type: "rxc1",
    },
    {
      image: inventry1,
      label: "Inventory Management",
      type: "",
    },
    {
      image: PicPack,
      label: "Pick N Pack",
      type: "pnp",
    },
    {
      image: reportsMain,
      label: "myReports",
      type: "myReports",
    },
    {
      image: epic,
      label: "Epic",
      type: "",
    },
    {
      image: myWork,
      label: "myWork",
      type: "",
    },
    {
      image: myDoc,
      label: "myDocs",
      type: "",
    },
    {
      image: CSVAppIcon,
      label: "CVS App Portal",
      type: "",
    },
  ];

export const storeData = [
  {
    image: Createticket,
    label: "Create Ticket",
    type: "createTicket",
  },
  {
    image: rxc1,
    label: "Recent Tickets",
    type: "recentTicket",
  },
  {
    image: inventry,
    label: "Service Channel",
    type: "",
  },
  {
    image: health,
    label: "Workbrain Administrat...",
    type: "",
  },
  {
    image: reports ,
    label: "myCustomer Connection",
    type: "",
  },
  {
    image: EpicIcon,
    label: "Think LP",
    type: "",
  },
  {
    image: MyWorkIcon,
    label: "My Colleagues",
    type: "",
  },
  {
    image: MyDocIcon,
    label: "Name Badge Printing",
    type: "",
  },
];


export const ticketData = [
  {
    image: cord,
    label: "CURLY PHONE CORD",
    subHeading: '1 remaining this month',
    type: "createTicket",
  },
  {
    image: ironman,
    label: "IRONMAN 1 BAY CHARGER",
    type: "",
    disable: true,
  },
  {
    image: ironman,
    label: "IRONMAN 1 BAY CHARGER ADAPTER CABLE",
    type: "",
    disable: true,
  },
  {
    image: ironmanBattery,
    label: "IRONMAN BATTERY",
    type: "",
    disable: true,
  },
  {
    image: ironmancase,
    label: "IRONMAN CASE",
    type: "",
    disable: true,
  },
  {
    image: trigger,
    label: "IRONMAN TRIGGER HANDLE",
    type: "",
    disable: true,
  },
  {
    image: sharp,
    label: "IRONMAN WRIST STRAP",
    type: "",
    disable: true,
  },
  {
    image: keyboard,
    label: "KEYBOARD - RX ONLY",
    type: "",
  },
  {
    image: mouse ,
    label: "MOUSE - RX ONLY",
    type: "",
  },
  {
    image: registerCenter,
    label: "REGISTER PRINTER CABLE - 2CR",
    type: "",
  },
  {
    image: registerPrinterBlack,
    label: "REGISTER PRINTER CABLE - 6145",
    type: "",
  },
  {
    image: registerScanner,
    label: "REGISTER SCANNER CABLE - HHP HONEYWELL 4600",
    type: "",
  },
];

export const meData = [
  {
    image: learningHub,
    label: "Learning Hub",
    type: "",
  },
  {
    image: cz,
    label: "Colleague Zone",
    type: "",
  },
  {
    image: time,
    label: "Time In/Out",
    type: "",
  },
  {
    image: reduser,
    label: "My Profile",
    type: "",
  },
  {
    image: heartWork ,
    label: "Heart At Work Reco...",
    type: "",
  },
  {
    image: mySuccess,
    label: "mySuccess",
    type: "",
  },
  {
    image: myPassword,
    label: "myPassword",
    type: "",
  },
  {
    image: myInsight,
    label: "myInsight",
    type: "",
  },
];